import React from "react";
import { classNames } from "./utils/classNames";
export const Badge = ({ color, extraClass, text, }) => (React.createElement("span", { className: classNames("badge", color, extraClass || "") }, text));
